/**
 * Decide whether reimburse Nilai Pajak must be forced to 0
 * based on No Faktur Pajak prefix codes from spb_commond_value_map.
 * Empty/missing codes => skip check (return false).
 */
export function shouldZeroReimburseTaxAmount(taxNo, codes) {
  if (!Array.isArray(codes) || codes.length === 0) {
    return false;
  }

  if (taxNo === null || taxNo === undefined || taxNo === '') {
    return false;
  }

  const normalizedTaxNo = String(taxNo);
  return codes.some((code) => {
    if (code === null || code === undefined || code === '') {
      return false;
    }
    return normalizedTaxNo.startsWith(String(code));
  });
}

export function applyReimburseTaxAmountByFakturPrefix(item, taxNo, codes) {
  const shouldZero = shouldZeroReimburseTaxAmount(taxNo, codes);
  if (shouldZero) {
    item.taxAmount = 0;
    item.AMOUNT = 0;
    item.amountLockedByFakturPrefix = true;
  } else {
    item.amountLockedByFakturPrefix = false;
  }
  return shouldZero;
}

/**
 * Vuelidate-friendly rule: amount may be 0 when locked by faktur prefix
 * or when taxNo matches a code from spb_commond_value_map. Otherwise > 0.
 */
export function isReimburseTaxAmountAllowed(value, siblings = {}, codes = []) {
  if (siblings?.amountLockedByFakturPrefix) {
    return true;
  }
  if (shouldZeroReimburseTaxAmount(siblings?.taxNo, codes)) {
    return true;
  }
  return value > 0;
}
